var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
// Design-system play/pause glyphs (Сергей's icon set).
const ICON_PLAY = `<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M6.98065 2.64379C8.13145 2.58866 8.85888 3.09253 9.79846 3.63976L11.0594 4.36475L15.2815 6.80878L17.6067 8.15497C18.0089 8.38683 18.6189 8.71455 18.9776 8.97224C19.3951 9.27377 19.7456 9.6584 20.0073 10.102C20.4987 10.95 20.6327 12.0239 20.38 12.9691C20.2127 13.6181 19.8666 14.2072 19.3814 14.6695C18.8638 15.1701 17.6826 15.7811 17.0061 16.172L13.722 18.071L10.319 20.0435C9.85034 20.3133 8.97138 20.8495 8.50121 21.0464C8.15356 21.1903 7.78613 21.2808 7.41141 21.3148C6.42643 21.3932 5.44999 21.0823 4.69149 20.4492C3.94429 19.8227 3.47695 18.9249 3.39255 17.9535C3.33663 17.2578 3.36932 16.1229 3.36972 15.402L3.37053 10.8363L3.36989 7.6728C3.36906 7.137 3.33737 6.20198 3.42286 5.71238C3.53814 5.06407 3.82502 4.4585 4.25372 3.95869C4.97692 3.1136 5.89272 2.73007 6.98065 2.64379Z"/></svg>`;
const ICON_PAUSE = `<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M16.0521 2.65701C16.2155 2.63551 16.9089 2.64092 17.098 2.64715C17.8108 2.67995 18.6488 2.56952 19.3409 2.72675C20.4815 2.98591 21.476 4.14704 21.6285 5.29489C21.6664 5.58129 21.653 5.92896 21.6528 6.21939L21.6518 7.56192L21.652 12.1047L21.6525 16.9852L21.6527 18.4341C21.6528 18.7361 21.6631 19.1323 21.6275 19.4239C21.563 19.9568 21.3523 20.4614 21.0184 20.8816C20.5064 21.5281 19.8161 21.8781 19.005 21.9684C18.4618 21.986 17.8841 21.9841 17.3388 21.9795C16.8402 21.9752 16.1333 22.0188 15.6601 21.9031C14.5244 21.6256 13.517 20.4602 13.3947 19.2995C13.3632 18.9996 13.3788 18.6352 13.3793 18.3322L13.3801 16.7753L13.3797 11.6347L13.3794 7.27976L13.3793 6.01968C13.3793 5.7593 13.3706 5.39174 13.4047 5.14362C13.4774 4.61299 13.6974 4.11337 14.0397 3.70144C14.5489 3.082 15.2609 2.73717 16.0521 2.65701Z"/><path d="M5.02326 2.65715C5.02899 2.6562 5.03472 2.65528 5.04045 2.65433C5.82409 2.63538 6.6186 2.65408 7.40184 2.6463C7.71404 2.64318 8.01876 2.65377 8.31332 2.72747C9.48791 3.02132 10.4376 4.13303 10.5988 5.3254C10.6357 5.60571 10.6201 5.96668 10.6199 6.25443L10.619 7.70874L10.6193 12.5854L10.6197 17.1784L10.6197 18.519C10.6195 18.7846 10.6275 19.1754 10.5944 19.4309C10.5279 19.9608 10.3175 20.4625 9.98623 20.8815C9.47047 21.5344 8.78912 21.8759 7.97298 21.9687C7.40999 21.9803 6.84687 21.9841 6.2838 21.9796C5.80201 21.9795 5.07633 22.0133 4.62571 21.9034C3.50784 21.631 2.50988 20.4822 2.37028 19.3454C2.33346 19.0455 2.34635 18.6715 2.34672 18.3616L2.34754 16.9429L2.34733 12.1104L2.34665 7.47993L2.34648 6.13642C2.3466 5.19907 2.3544 4.49524 2.99449 3.7201C3.52118 3.08226 4.2039 2.73819 5.02326 2.65715Z"/></svg>`;
let BwPlayButton = class BwPlayButton extends BwElement {
    constructor() {
        super(...arguments);
        this.playing = false;
        this.loading = false;
        this.disabled = false;
        this.size = 'lg';
        this._onClick = (e) => {
            if (this.disabled || this.loading) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            this.dispatchEvent(new CustomEvent('bw-play-click', {
                detail: { playing: this.playing },
                bubbles: true,
                composed: true,
            }));
        };
    }
    render() {
        return html `
      <button
        type="button"
        class="bw-play-inner"
        aria-label=${this.playing ? 'Pause' : 'Play'}
        aria-busy=${this.loading ? 'true' : 'false'}
        ?disabled=${this.disabled || this.loading}
        @click=${this._onClick}
      >
        <span class="bw-play-icon" .innerHTML=${this.playing ? ICON_PAUSE : ICON_PLAY}></span>
        ${this.loading
            ? html `<span class="bw-play-spinner" aria-hidden="true"></span>`
            : ''}
      </button>
    `;
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], BwPlayButton.prototype, "playing", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwPlayButton.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwPlayButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwPlayButton.prototype, "size", void 0);
BwPlayButton = __decorate([
    customElement('bw-play-button')
], BwPlayButton);
export { BwPlayButton };
//# sourceMappingURL=bw-play-button.js.map